import { render, staticRenderFns } from "./Preparation.vue?vue&type=template&id=ebe96136&scoped=true&"
import script from "./Preparation.vue?vue&type=script&lang=ts&"
export * from "./Preparation.vue?vue&type=script&lang=ts&"
import style0 from "./Preparation.vue?vue&type=style&index=0&id=ebe96136&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe96136",
  null
  
)

export default component.exports